import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledSingleSelectDDItem,
    StyledSingleSelectDDItemText,
} from "app/pages/sales-intelligence/common-components/dropdown/styles";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { DROPDOWN_ID } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalTemplatesDropdown/const";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

type Props = {
    template: SignalTemplate<SignalFilters>;
    tag?: ReactElement;
    hideDescriptionTooltip?: boolean;
};

const SignalTemplateDropdownItem = ({ template, tag, hideDescriptionTooltip = false }: Props) => {
    return (
        <StyledSingleSelectDDItem>
            <FlexRow>
                <I18n
                    data-automation={`${DROPDOWN_ID}-item-text`}
                    element={StyledSingleSelectDDItemText}
                    translatable={template.name}
                />

                {tag}
            </FlexRow>

            {hideDescriptionTooltip ? null : (
                <Tooltip content={translate(template.description.key)}>
                    <div>
                        <SWReactIcons
                            iconName="info"
                            size="xs"
                        />
                    </div>
                </Tooltip>
            )}
        </StyledSingleSelectDDItem>
    );
};

export default SignalTemplateDropdownItem;
